export default __webpack_public_path__ + "assets/40ce764f1c081cad35a840dd348e1d14.jpg";